import { registerDestructor } from '@ember/destroyable';
import { type Registry as Services, service } from '@ember/service';
import Modifier from 'ember-modifier';

interface TrackColumnHoverSignature {
  Args: {
    Positional: [columnId: string];
  };
  Element: Element;
}

function cleanup(instance: TrackColumnHoverModifier): void {
  instance.element?.removeEventListener('mouseenter', instance.onMouseEnter);
  instance.element?.removeEventListener('mouseleave', instance.onMouseLeave);
}

export default class TrackColumnHoverModifier extends Modifier<TrackColumnHoverSignature> {
  @service('channel-pricing/table-hover')
  declare channelPricingTableHover: Services['channel-pricing/table-hover'];

  columnId: string | null = null;
  element: Element | null = null;

  onMouseEnter = (): void => {
    this.channelPricingTableHover.hoveredColumnId = this.columnId;
  };

  onMouseLeave = (): void => {
    this.channelPricingTableHover.hoveredColumnId = null;
  };

  modify(
    element: TrackColumnHoverSignature['Element'],
    [columnId]: TrackColumnHoverSignature['Args']['Positional'],
  ): void {
    this.columnId = columnId;

    if (this.element) {
      return;
    }

    this.element = element;
    element.addEventListener('mouseenter', this.onMouseEnter);
    element.addEventListener('mouseleave', this.onMouseLeave);

    registerDestructor(this, cleanup);
  }
}
